import { toast } from "react-toastify";
import { IoMdSend } from "react-icons/io";

import { isEmailValid } from "@Utils/functions";
import IconButton from "@Components/IconButton";
import TextField from "@Components/Inputs/TextField";

import styles from "./AddEmail.module.scss";
import { CommonProps } from "../SupportMachine/types";
import { handleInteraction } from "../SupportMachine/stateMachineInteractions";

export default function AddEmail({
  state,
  setState,
  text,
  setText,
}: CommonProps) {
  const handleAddDescription = (newText: string) => {
    if (newText && isEmailValid(newText)) {
      handleInteraction({
        participant: newText,
        prevState: state,
        optionIndex: 0,
        currentState: state.name,
        setState,
      });
      setText("");
    } else {
      toast.warn("Invalid email!", {
        position: "top-center",
      });
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.textArea}>
        <TextField
          type="email"
          required
          id="email"
          value={text}
          placeholder="Add additional email"
          onChange={(e) => setText(e.target.value)}
        />
        <IconButton onClick={() => handleAddDescription(text)}>
          <IoMdSend size={35} fill="#6b97f6" />
        </IconButton>
      </div>
    </div>
  );
}
